import React, {useState, useEffect} from 'react';
import { Container } from '_atoms';
import { Colors, Spacing, Typography } from '_styles';
import { selectScreen, selectScreenStatus, setScreen } from '_redux/slices/main-screen/render-screen';
import { selectRewards, selectRewardsStatus, fetchRewards, setSelectedReward } from '_redux/slices/prm-club/rewards';
import { useSelector, useDispatch, } from 'react-redux';
import Spinner from 'react-bootstrap/Spinner' 

const AdminRewardTile = (props) => {

    const [over, setOver] = useState(false);
    const [imageLoading, setImageLoading] = useState(true);                          
                          
    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch(setSelectedReward(props.reward))
        props.setScreen("edit-reward")
    }

    return (
        <Container style={{cursor:'pointer'}} onClick={handleClick} onMouseOver={()=>{setOver(true)}} onMouseLeave={()=>{setOver(false)}}>
            
            {/* Image */}
            <Container style={{ width:Spacing.SCALE_300, height:Spacing.SCALE_280}}>
                <img 
                    src={props.reward.photo}
                    style={{
                        width:'100%',
                        height:'100%',
                        borderRadius:10,
                        boxShadow:"0px 6px 6px 0px #9E9E9E",
                        borderStyle:'solid', 
                        borderColor: over ? Colors.PRM_LIGHT_BLUE : 'white'
                    }}
                    onLoad={()=>{setImageLoading(false)}}
                />
                {
                    imageLoading ? 
                    <div style={{marginTop:-150, marginLeft:130}}>
                        <Spinner
                            as="span"
                            animation="border"
                            role="status"
                            aria-hidden="true"
                            variant="primary"
                        />
                    </div>
                    
                    :
                    <p></p>
                }
            </Container>

            {/* Title */}
            <div style={{marginLeft:Spacing.SCALE_8, marginTop:Spacing.SCALE_8}}>
                <p style={{fontSize:26, fontWeight:'200', color: over ? Colors.PRM_LIGHT_BLUE : 'black'}}>{props.reward.retailer}</p>
                <p style={{fontSize:14, fontWeight:'500', opacity: over ? 1.0 : 0.5, color: over ? Colors.PRM_LIGHT_BLUE : 'black', marginTop:-Spacing.SCALE_8}}>{props.reward.title}</p>
            </div>
                
        </Container>
    );
}


export default AdminRewardTile;